// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1__d258b7f2f532bbd9ce07","cls2":"MultiPaperModal-cls2___4a07bb53ddbd8c8d660 MultiPaperModal-cls1__d258b7f2f532bbd9ce07"};